import React, { useState, useEffect, useRef, useCallback } from 'react';
import listImg from "../../assets/images/DRONE_BANANA_ISLAND_MASTER.png";
import { HiDownload } from "react-icons/hi";
import { MdOutlineZoomOutMap, MdOutlinePlayCircle, MdTune, MdKeyboardArrowRight, MdKeyboardArrowLeft } from "react-icons/md";
import ListPopup from './list-show-all-popup';
import { apiCallingPost, apiCallingGetDecrypted } from '../../api/services';
import { ToastContainer, toast } from 'react-toastify';
import Loader from "../../assets/images/loader.gif"
import { useSelector, useDispatch } from "react-redux";
import {
  setFileType, setSearchText, setOffsetTag, setPageSizeTag, setSearchMode, setShowMoreTag,
  setHasMoreTag, setTextTrigger, setTagList
} from '../../redux/reducers/commonSlice';
import { setSelectedQuality, setCurrentPlaybackRate, setViewType, setVolume, setIsMuted } from '../../redux/reducers/commonSliceWhiteList';
import { IoSettingsSharp, IoLocationOutline } from "react-icons/io5";
import { MdOutlinePermMedia } from "react-icons/md";
import { GrMultimedia } from "react-icons/gr";
import { CiCalendarDate } from "react-icons/ci";
import { IoIosResize } from "react-icons/io";
import { FaVolumeMute, FaVolumeUp, FaVolumeDown } from "react-icons/fa";
import { MdPictureInPicture, MdCloseFullscreen } from "react-icons/md";
import { RiDeleteBinLine } from "react-icons/ri";
import { debounce } from 'lodash';
import { IoShareSocialOutline } from "react-icons/io5";
import { FiEdit2 } from "react-icons/fi";
import ListUpload from './show-more-list-edit';
import { FiLink, FiMail } from "react-icons/fi";
import { IoCloseOutline } from "react-icons/io5";
import { BiDownload, BiFile } from "react-icons/bi";
import { FaDownload, FaEye } from "react-icons/fa";

let totalCountTagNum
let url
function ListShowAll(props) {
  const dispatch = useDispatch();
  const { fileType, searchText, offsetTag, pageSizeTag, searchMode, showMoreTag, hasMoreTag,
    textTrigger, tagList, totalCountTag, loadingTag, searchType, tagNames, tagNameFlag } = useSelector((state) => state.commonData)
  const { selectedQuality, currentPlaybackRate, speeds, viewType, volume, isMuted } = useSelector((state) => state.commonDataWhiteList)
  const videoRefs = useRef({});
  const lastElementRef = useRef(null);
  const observer = useRef();
  const popupRef = useRef(null);
  const dropdownRef = useRef(null);

  const [tagListMore, setTagListMore] = useState([]);
  const [selectedData, setSelectedData] = useState([]);
  const [tagPopupFlag, setTagPopupFlag] = useState(false);
  const [hoveredVideoId, setHoveredVideoId] = useState(null);
  const [activeSettings, setActiveSettings] = useState(null);
  const [quality, setQuality] = useState(true);
  const [speedFlag, setSpeedFlag] = useState(true);
  const [pipVideoId, setPipVideoId] = useState(null);
  const [popupList, setPopupList] = useState(false);
  const [selectData, setSelectData] = useState([]);
  const [selectIndex, setSelectIndex] = useState("");
  const [mode, setMode] = useState("");
  const [isShareLink, setIsShareLink] = useState(false)
  const [shareMode, setShareMode] = useState("Viewer")
  const [selectedVideoIds, setSelectedVideoIds] = useState([]);
  const [videoIDsIndividual, setVideoIDsIndividual] = useState([]);
  const [isDownload, setIsDownload] = useState(false)
  const [isOriginalCheck, setIsOriginalCheck] = useState(false);
  const [isMp4Check, setIsMp4check] = useState(false)
  const [isVideoFormatSelect, setIsVideoFormatSelect] = useState(true)
  const [hasVideo, setHasVideo] = useState(false);
  const [copiedIndex, setCopiedIndex] = useState(null);
  const [popupShareStates, setPopupShareStates] = useState({});
  const [popupReject, setPopupReject] = useState(false);
  const [isMultipleDownload, setIsMultipleDownload] = useState(false);
  const [selectedDownloadVideo, setSelectedDownloadVideo] = useState([]);
  const [selectedDownloadVideoALL, setSelectedDownloadVideoALL] = useState([]);
  const [selectedDownloadVideoMode, setSelectedDownloadVideoMode] = useState("Single");
  const [selectedQualities, setSelectedQualities] = useState({});
  const [totalFileSize, setTotalFileSize] = useState(0)
  const [isDownloadBtn, setIsDownloadBtn] = useState(false)
  const [rejectData, setRejectData] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [isDelete, setIsDelete] = useState(false)
  const [selectedToDelete, setSelectedToDelete] = useState(null);
  const [selecteddownloadItems, setSelecteddownloadItems] = useState([]);
  useEffect(() => {
    if (offsetTag === 0) {
      // Reset when offset is 0 (new search)
      setTagListMore(tagList);
    } else {
      // Append new items when loading more
      setTagListMore(prev => [...prev, ...tagList]);
    }
  }, [tagList]);
  useEffect(() => {
    const total = getTotalSizeInMB(selectedDownloadVideoALL);
    const formattedSize = getTotalSizeMB(total);
    setTotalFileSize(formattedSize)
  }, [selectedDownloadVideoALL]);
  const getTotalSizeInMB = (videoArray) => {
    let totalSize = 0;
    videoArray.forEach(video => {
      let sizeInMB;
      if (video.download_original || video.download_original === "" || props?.userData?.hasFullAccess) {
        // Use original size from `videoObj.size`
        sizeInMB = parseFloat(video.size);
        setSelectedQualities(prev => {
          const updated = {
            ...prev,
            [video.video_id]: { quality: "Download Original", size: sizeInMB }
          };
          return updated;
        });
      } else if (Array.isArray(video.qualityvariants) && video.qualityvariants.length > 0) {

        // Use the first quality variant size
        sizeInMB = parseFloat(video.qualityvariants[0].qualityvideosize);
        setSelectedQualities(prev => {
          const updated = {
            ...prev,
            [video.video_id]: { quality: video.qualityvariants[0].qualitytype, size: sizeInMB }
          };
          return updated;
        });
      } else {
        sizeInMB = 0; // fallback
      }
      const sizeString = sizeInMB.toString().trim().toUpperCase(); // Ensure "MB"
      const value = parseFloat(sizeString.replace("MB", ""));
      totalSize += isNaN(value) ? 0 : value;
    });
    return totalSize.toFixed(2); // Round to 2 decimals
  };
  const lastElementObserver = useCallback(node => {
    if (loadingTag == "true") return;
    if (observer.current) observer.current.disconnect();
    let newOffset = offsetTag + pageSizeTag

    observer.current = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting && totalCountTag > newOffset) {
        dispatch(setOffsetTag(newOffset));
      }
    }, {
      rootMargin: '100px',
      threshold: 0.1
    });

    if (node) observer.current.observe(node);
  }, [loadingTag, hasMoreTag]);

  useEffect(() => {
    const currentRef = lastElementRef.current;
    if (currentRef) {
      lastElementObserver(currentRef);
    }
    return () => {
      if (observer.current) {
        observer.current.disconnect();
      }
    };
  }, [lastElementObserver, tagListMore]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setActiveSettings(null);
        setSpeedFlag(true);
        setQuality(true);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  useEffect(() => {
    //  if(searchType === 1){
    setSelectedDownloadVideoALL([])
    setSelectedDownloadVideo([])
    setSelecteddownloadItems([])
    setSelectedVideoIds([])
    setSelectedItems([])
    //  }
  }, [searchType]);


  const handleQualityChange = (quality) => {
    dispatch(setSelectedQuality(quality));

    if (hoveredVideoId) {
      const list = tagListMore.find(
        (data) => data.id === hoveredVideoId
      );
      const videoElement = videoRefs.current[hoveredVideoId];
      if (list && videoElement) {
        const newSrc =
          list?.video_variants?.find((q) => q.quality_type === quality)?.name ||
          list.url;

        if (newSrc && videoElement.src !== newSrc) {
          const wasPlaying = !videoElement.paused;
          const currentTime = videoElement.currentTime;

          videoElement.src = newSrc;
          videoElement.load();

          videoElement.onloadeddata = () => {
            videoElement.currentTime = currentTime;
            if (wasPlaying) {
              videoElement.play().catch(console.error);
            }
          };
        }
      }
      setActiveSettings(false);
    }
  };

  const toggleSettings = (videoId) => {
    setActiveSettings(activeSettings == videoId ? null : videoId);
    setHoveredVideoId(null);
    setSpeedFlag(true);
    setQuality(true);
  };

  const handleMouseEnter = (videoId) => {
    setHoveredVideoId(videoId);
    const videoElement = videoRefs.current[videoId];
    if (videoElement) {
      const list = tagListMore.find((data) => data.id === videoId);
      if (list) {
        const videoSrc =
          list?.video_variants?.find(
            (item) => item.quality_type === selectedQuality
          )?.name || list?.url;

        // Set the src only when hovered
        if (videoElement.src !== videoSrc) {
          videoElement.src = videoSrc;
          videoElement.load();
        }
      }
      videoElement.play().catch((err) => console.error(err));
    }
  }

  const handleMouseLeave = (videoId) => {
    setHoveredVideoId(null);
    const videoElement = videoRefs.current[videoId];
    if (videoElement) {
      videoElement.pause();
    }
    setActiveSettings(null);
    setSpeedFlag(true);
    setQuality(true);
  }

  const popupTagShow = (data) => {
    setSelectedData(data);
    setTagPopupFlag(true);
    document.body.style.overflow = 'hidden';
  };

  const showSpeed = () => {
    setSpeedFlag(!speedFlag);
  };

  const backToList = () => {
    setSpeedFlag(true);
  };

  const showQuality = () => {
    setQuality(!quality);
  };

  const backToQuality = () => {
    setQuality(true);
  };
  const handlePiP = async (videoId) => {
    const videoElement = videoRefs.current[videoId];

    if (!document.pictureInPictureElement) {
      try {
        await videoElement.requestPictureInPicture();
        setPipVideoId(videoId);
      } catch (error) {
        console.error('Failed to enter PiP:', error);
      }
    } else {
      try {
        await document.exitPictureInPicture();
        setPipVideoId(null);
      } catch (error) {
        console.error('Failed to exit PiP:', error);
      }
    }
  };
  const handlePlaybackRateChange = (rate, videoId, isIndividual = false) => {
    if (isIndividual) {

      const video = videoRefs.current[videoId];
      if (video) {
        const wasPlaying = !video.paused;
        const currentTime = video.currentTime;

        video.playbackRate = rate;

        if (wasPlaying) {
          video.play().catch(error => {
            console.error("Error playing video:", error);
          });
        }
        video.currentTime = currentTime;
      }
    } else {
      dispatch(setCurrentPlaybackRate(rate));

      Object.keys(videoRefs.current).forEach((id) => {
        const video = videoRefs.current[id];
        if (video) {
          const wasPlaying = !video.paused;
          const currentTime = video.currentTime;

          video.playbackRate = rate;

          if (wasPlaying) {
            video.play().catch(error => {
              console.error("Error playing video:", error);
            });
          }
          video.currentTime = currentTime;
        }
      });
      setActiveSettings(false);
    }
  };

  const handleVolumeChange = (e) => {
    dispatch(setVolume(e.target.volume));
    dispatch(setIsMuted(e.target.muted));
  };

  useEffect(() => {
    Object.values(videoRefs.current).forEach(video => {
      if (video) {
        video.volume = volume;
        video.muted = isMuted;
      }
    });
  }, [volume, isMuted]);

  const cancelpopup = () => {
    setTagPopupFlag(false);
    document.body.style.overflow = 'auto';
    setIsMultipleDownload(false)
    // setSelectedDownloadVideo([])
    setSelectedQualities({})
    setIsDownloadBtn(false)
    setIsVideoFormatSelect(true)
    setShareMode("Viewer")
    // setSelecteddownloadItems([])
  };
  const deleteList = async () => {
    // if (window.confirm("Do you want to delete?")) {
    if (!selectedToDelete) return;
    let postData = {
      videoIds: [selectedToDelete.video_id],
      userId: props.userData.userId
    };
    try {
      const { data: responseData } = await apiCallingPost("api/video/deleteVideo", postData);
      if (responseData.success === "1") {
        toast.success(`Media deleted successfully.`);
        setTimeout(() => {
          //props.getData("", "");
          setSelectedToDelete(null);
        }, 1000);
      } else {
        toast.error(`Something went wrong.`);
      }
    } catch (error) {
      console.error("Error Deleting Video:", error);
    }
    deletePopupCancel();
    // }
  };
  const listPopup = (data, mode, index) => {
    setPopupList(true);
    setMode(mode);
    setSelectIndex(index);
    setSelectData(data);
    document.body.style.overflow = 'hidden';
  };
  const sendMail = async (mailData) => {
    let postData = {
      functionName: "sendMailToUsers",
      jsonMailOptions: mailData
    };
    try {
      await apiCallingPost(postData);
    } catch (error) {
      console.error("Error sending mail:", error);
    }
  };
  const cancelPopup = () => {
    setPopupList(false);
    setPopupReject(false);
    setTagPopupFlag(false);
    setIsShareLink(false);
    setIsDownload(false)
    setIsMp4check(false);
    setIsOriginalCheck(false)
    setIsVideoFormatSelect(true)
    document.body.style.overflow = 'auto';
  };
  const linkCopy = (ids, mode, list, index) => {
    if (!isOriginalCheck && !isMp4Check && isDownload && hasVideo) {
      setIsVideoFormatSelect(false)
      document.getElementById("originalVedioCheck")
      return;
    } else {
      if (isDownload) {
        setIsVideoFormatSelect(true)
      }
      setShareMode("Viewer")

      const uniqueArr = [...new Set(ids)];
      let videoIds = (ids.length > 0 ? ids : videoIDsIndividual)
      shareMedia(videoIds, url, mode)
      const shareElement = document.getElementById("link-copy-common");
      if (shareElement && isVideoFormatSelect) {
        shareElement.classList.toggle("d-none");
        setTimeout(() => {
          shareElement.classList.toggle("d-none")
          cancelPopup()
        }
          , 1500);
      }
      navigator.clipboard.writeText(url)
        .then(() => {
          // setCopiedIndex(list.video_id);
          setTimeout(() => {
            setCopiedIndex(null)
            // setSelectedVideoIds([])
            // setSelectedItems([])
          }
            , 1500);
        })
        .catch((err) => {
          console.error("Failed to copy text: ", err);
        });
    }

  };
  const shareMedia = async (ids, url, mode, heading, encodedBody, index) => {
    let postData = {
      videoId: ids,
      userId: props.userData.userId,
      requestedOn: new Date().getTime(),
      encodedVideoUrl: url,
      mode: shareMode,
      downloadOriginal: isOriginalCheck,//1 or 0
      downloadMp4: isMp4Check//1 or 0
    };

    try {
      const { data: responseData } = await apiCallingPost("api/video/saveShareRequest", postData);

      if (responseData.success === "1") {
        if (mode == "mail") {
          window.location.href = `mailto:someone@example.com?subject=${encodeURIComponent(heading || 'Qatar')}&body=${encodedBody}`;
        }
        if (index !== undefined) {
          setPopupShareStates((prevStates) => ({
            ...prevStates,
            [index]: !prevStates[index],
          }));
        }
      } else {
        toast.error("Please try again.");
      }
    } catch (error) {
      console.error("Error fetching user list:", error);
    }
  }
  const listSharePopup = async (ids, mode, list, index) => {

    const heading = list?.video_heading || '';
    const description = list?.description || '';
    let body = '';

    if (index !== undefined) {
      body = `Hi,
  
       ${heading}
  
        ${description ? `Description: ${description}\n\n` : ''}
        View it here: ${url}
  
        Best regards,
        Qatar`;
    } else {
      body = `Hi,
        View it here: ${url}
  
        Best regards,
        Qatar`;
    }

    const encodedBody = encodeURIComponent(body);
    shareMedia(ids, url, mode, heading, encodedBody, index)
  };
  const uuidv4 = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx'.replace(/[xy]/g, function (c) {
      const r = (Math.random() * 16) | 0,
        v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  };
  const downloadSingle = async (videoObj, i) => {
    if (videoObj.downloadStatus === "APPROVED" || props?.userData?.hasFullAccess) {
      setIsMultipleDownload(true)
      setSelectedDownloadVideoMode("Single")
      setSelectedDownloadVideo([videoObj]);
      // Determine size based on `download_original`
      let sizeInMB;
      if (videoObj.download_original || videoObj.download_original === "" || props?.userData?.hasFullAccess) {
        // Use original size from `videoObj.size`
        sizeInMB = parseFloat(videoObj.size);

      } else if (Array.isArray(videoObj.qualityTypeArray) && videoObj.qualityTypeArray.length > 0) {
        // Use the first quality variant size
        sizeInMB = parseFloat(videoObj.qualityTypeArray[0].qualityvideosize);
        // const formattedSize = getTotalSizeMB(sizeInMB);
        setSelectedQualities(prev => {
          const updated = {
            ...prev,
            [videoObj.video_id]: { quality: videoObj.qualityTypeArray[0].qualitytype, size: sizeInMB }
          };
          return updated;
        });
      } else {
        sizeInMB = 0; // fallback
      }
      const formattedSize = getTotalSizeMB(sizeInMB);
      setTotalFileSize(formattedSize);
      setIsDownloadBtn(true)

    } else
      if (props.userData.roleDisplayName === "User" && (videoObj.downloadStatus === "" || videoObj.downloadStatus === "REJECTED")) {
        const postData = {
          video_id: [videoObj.video_id],
          user_id: props.userData.userId,
          created_on: new Date().getTime(),
        };

        try {
          const { data: responseData } = await apiCallingPost(
            "api/video/saveVideoDownloadRequest",
            postData
          );

          if (responseData.success === "1") {
            toast.success("Media download request submitted.");
            props.getData("", "");
          }
        } catch (error) {
          console.error("Error submitting download request:", error);
        }
      } else if (videoObj.downloadStatus === "OPEN") {
        toast.warning("You already sent a request.");
      }
    // else {
    //   setIsMultipleDownload(true)
    //   setSelectedDownloadVideo([videoObj]);
    //   const formattedSize = getTotalSizeMB(videoObj.size);
    //   setTotalFileSize(formattedSize)
    //   setIsDownloadBtn(true)
    // }


  }
  const getTotalSizeMB = (mb) => {
    if (mb >= 1024 * 1024) return `${(mb / (1024 * 1024)).toFixed(2)} TB`;
    if (mb >= 1024) return `${(mb / 1024).toFixed(2)} GB`;
    return `${mb} MB`;
  };
  const handleVideoQualityChange = (videoId, selectedQuality, sizes) => {
    const selectedVideoSize = sizes.find(q => q.qualitytype === selectedQuality)?.qualityvideosize || 0;

    setSelectedQualities(prev => {
      const updated = {
        ...prev,
        [videoId]: { quality: selectedQuality, size: selectedVideoSize }
      };
      // Update total size
      const totalSizeMB = selectedDownloadVideo.reduce((sum, video) => {
        const selected = updated[video.video_id];
        return sum + (selected?.size ? Number(selected.size) : Number(video.size.split(' ')[0]));
      }, 0);
      const formattedSize = getTotalSizeMB(totalSizeMB.toFixed(2));
      setTotalFileSize(formattedSize);
      return updated;
    });
  };
  const handleSingleDownload = async (video, selectedQualityObj) => {

    const resolutionType = selectedQualityObj?.quality === "Download Original" || !selectedQualityObj?.quality
      ? ""
      : selectedQualityObj.quality;
    const requestPayload = [{
      fileId: video.video_id,
      type: resolutionType
    }];

    const encoded = encodeURIComponent(JSON.stringify(requestPayload));

    try {
      const { responseData } = await apiCallingGetDecrypted(`api/download/download_zip?videoId=${encoded}`);
      const link = document.createElement('a');
      link.href = responseData;
      link.download = `${video.filename}.${video.file_extension}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      console.error("Single download failed", err);
    }
  };
  const handleDownloadAll = async () => {
    const selectedResolutionArray = getSelectedQualityArray();
    const encoded = encodeURIComponent(JSON.stringify(selectedResolutionArray));

    const { responseData } = await apiCallingGetDecrypted(`api/download/download_zip?videoId=${encoded}`);
    const link = document.createElement('a');
    link.href = responseData;
    link.download = "video.zip" // optional: helps some browsers
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  const getSelectedQualityArray = () => {
    return selectedDownloadVideo.map((video) => {
      const selected = selectedQualities[video.video_id];
      return {
        fileId: video.video_id,
        type: selected?.quality === "Download Original" || !selected?.quality ? "" : selected.quality,
      };
    });
  };
  const approveList = async (data) => {
    let postData = {
      videoId: [data.video_id],
      userId: props?.userData?.userId
    };
    try {
      const { data: responseData } = await apiCallingPost("api/video/approveVideo", postData);
      if (responseData.success === "1") {
        toast.success(`Media Approved successfully.`);
        let jsonMailOptions = responseData.result;
        setTimeout(() => {
          props.getData("", "");
        }, 1000);
      } else {
        toast.error(`Something went wrong.`);
      }
    } catch (error) {
      console.error("Error Approved Video:", error);
    }
  };
  const rejectPopup = (data) => {
    setRejectData(data);
    setPopupReject(true);
    document.body.style.overflow = 'hidden';
  };
  const handledownloadCheckboxChange = (e, videoObj, id) => {
    let updatedVideoObjects = [...selectedDownloadVideo];
    let updatedVideoIds = [...selecteddownloadItems];
    let vids = (videoObj.video_id == id ? videoObj.video_id : id)
    if (e.target.checked) {
      // Add video object if not already present
      if (!updatedVideoObjects.some(v => v.id === videoObj.id)) {
        updatedVideoObjects.push(videoObj);
      }
      if (!updatedVideoIds.includes(vids)) {
        updatedVideoIds.push(vids);
      }
      // updatedVideoObjects.push(videoObj)
      // updatedItems.push(videoObj.video_id)
      // setSelectedDownloadVideo(prev => [...prev, videoObj]);
    } else {
      // updatedIds = updatedIds.filter(itemId => itemId !== vid);
      updatedVideoIds = updatedVideoIds.filter(item =>
        (videoObj.video_id == id ? item !== videoObj.video_id || item !== vids : item !== vids)
      );

      const stillHasSegmentsofVideo = updatedVideoIds.some(item => item.video_id === videoObj.video_id);

      if (!stillHasSegmentsofVideo) {
        // Remove from selectedVideoIds only if no segments remain
        updatedVideoObjects = updatedVideoObjects.filter(v => v.id !== videoObj.video_id);
      }
      // setSelectedDownloadVideo(prev => prev.filter(item => item.video_id !== videoObj.video_id));
    }
    const uniqueVideos = updatedVideoObjects.filter(
      (video, index, self) =>
        index === self.findIndex(v => v.video_id === video.video_id)
    );
    const totalSizeMB = uniqueVideos.reduce((sum, video) => {
      const selected = video;
      return sum + (selected?.size ? Number(selected.size) : Number(video.size.split(' ')[0]));
    }, 0);

    const formattedSize = getTotalSizeMB(totalSizeMB.toFixed(2));

    setTotalFileSize(formattedSize);

    setSelectedDownloadVideo(updatedVideoObjects);
    setSelecteddownloadItems(updatedVideoIds);
  }
  const handleCheckboxChange = (e, videoId, fileTypeId, id, videoObj) => {
    setVideoIDsIndividual([])

    let updatedIds = [...selectedVideoIds];
    let updatedItems = [...selectedItems];
    let vid = (videoId == id ? videoId : id)
    if (e.target.checked) {
      updatedIds.push(videoId);
      updatedItems.push({ video_id: videoId, type_flag: fileTypeId, id: vid });
    } else {
      // Remove this specific segment from updatedItems
      updatedItems = updatedItems.filter(item =>
        (videoId == id ? item.video_id !== videoId || item.id !== vid : item.id !== vid)
      );
      // Check if this videoId still has any segment selected
      const stillHasSegments = updatedItems.some(item => item.video_id === videoId);

      if (!stillHasSegments) {
        // Remove from selectedVideoIds only if no segments remain
        updatedIds = updatedIds.filter(id => id !== videoId);
      }
      const shareElement = document.getElementById("share-common");
      if (shareElement) {
        shareElement.classList.add("d-none");
      }
    }
    // Update states
    setSelectedVideoIds(updatedIds);
    setSelectedItems(updatedItems);
    // Set flags
    //const hasImage = updatedItems.some(item => item.type_flag === 1);
    const hasVideo = updatedItems.some(item => item.type_flag === 2);
    setHasVideo(hasVideo)
    //////////------------ForDownload selection---------//////////
    let updatedVideoObjects = [...selectedDownloadVideoALL];
    let updatedVideoIds = [...selecteddownloadItems];
    let vids = (videoObj.video_id == id ? videoObj.video_id : id)
    if (e.target.checked) {
      // Add video object if not already present
      if (!updatedVideoObjects.some(v => v.id === videoObj.id)) {
        updatedVideoObjects.push(videoObj);
      }
      if (!updatedVideoIds.includes(vids)) {
        updatedVideoIds.push(vids);
      }
    } else {
      updatedVideoIds = updatedVideoIds.filter(item =>
        (videoObj.video_id == id ? item !== videoObj.video_id || item !== vids : item !== vids)
      );

      const stillHasSegmentsofVideo = updatedVideoIds.some(item => item.video_id === videoObj.video_id);
      if (!stillHasSegmentsofVideo) {
        // Remove from selectedVideoIds only if no segments remain
        updatedVideoObjects = updatedVideoObjects.filter(v => v.id !== videoObj.id);
      }
    }
    const uniqueVideos = updatedVideoObjects.filter(
      (video, index, self) =>
        index === self.findIndex(v => v.video_id === video.video_id)
    );
    const totalSizeMB = uniqueVideos.reduce((sum, video) => {
      const selected = video;
      return sum + (selected?.size ? Number(selected.size) : Number(video.size.split(' ')[0]));
    }, 0);

    const formattedSize = getTotalSizeMB(totalSizeMB.toFixed(2));

    setTotalFileSize(formattedSize);
    setSelectedDownloadVideoALL(updatedVideoObjects);
    setSelecteddownloadItems(updatedVideoIds);
  };
  const downloadMultiple = async () => {
    // if (props.userData.roleDisplayName === "User" && props?.userData?.hasFullAccess) {
    if (props?.userData?.hasFullAccess) {
      const uniqueArray = selectedDownloadVideoALL.filter((item, index, self) =>
        index === self.findIndex((obj) => obj.video_id === item.video_id)
      );
      setSelectedDownloadVideoALL(uniqueArray);
      setSelectedDownloadVideoMode("Multiple")
      setIsMultipleDownload(true);
    } else
      // if (props.userData.roleDisplayName === "User" && !props?.userData?.hasFullAccess) {
      if (!props?.userData?.hasFullAccess) {
        setSelectedDownloadVideoMode("Multiple")
        const pendingOrRejected = [];
        const approvedVideos = [];
        const openVideos = [];

        (selectedDownloadVideoALL || []).forEach((video) => {
          if (video.downloadStatus === "" || video.downloadStatus === "REJECTED") {
            pendingOrRejected.push(video.video_id);
          } else if (video.downloadStatus === "OPEN") {
            openVideos.push(video.video_id);
          } else {
            approvedVideos.push(video);
          }
        });

        const total = selectedDownloadVideoALL.length;

        if (approvedVideos.length === total) {
          setSelectedDownloadVideo(approvedVideos);
          setIsMultipleDownload(true);
          return;
        }

        if (openVideos.length === total) {
          toast.warn("All videos are currently pending approval.");
          return;
        }

        if (pendingOrRejected.length === total) {
          const postData = {
            video_id: pendingOrRejected,
            user_id: props.userData.userId,
            created_on: new Date().getTime(),
          };

          try {
            const { data: responseData } = await apiCallingPost(
              "api/video/saveVideoDownloadRequest",
              postData
            );

            if (responseData.success === "1") {
              toast.success("Approval requests have been sent for all videos.");
              props.getData("", "");
            }
          } catch (error) {
            console.error("Error submitting download request:", error);
          }
          return;
        }

        // Handle mixed cases
        if (approvedVideos.length > 0) {
          setSelectedDownloadVideoALL(approvedVideos);
          setIsMultipleDownload(true);
        }

        let messageParts = [];

        if (approvedVideos.length > 0) {
          messageParts.push(`${approvedVideos.length} ${approvedVideos.length === 1 ? "video is" : "videos are"} approved`);
        }

        if (openVideos.length > 0) {
          messageParts.push(`${openVideos.length} ${openVideos.length === 1 ? "is" : "are"} pending approval`);
        }

        if (pendingOrRejected.length > 0) {
          const postData = {
            video_id: pendingOrRejected,
            user_id: props.userData.userId,
            created_on: new Date().getTime(),
          };

          try {
            const { data: responseData } = await apiCallingPost(
              "api/video/saveVideoDownloadRequest",
              postData
            );

            if (responseData.success === "1") {
              messageParts.push(`approval requests have been sent for ${pendingOrRejected.length} ${pendingOrRejected.length === 1 ? "video" : "videos"}`);
              toast.success(messageParts.join(", ") + ".");
              props.getData("", "");
            }
          } catch (error) {
            console.error("Error submitting download request:", error);
          }
        } else {
          // If nothing new to request, still show toast if needed
          if (messageParts.length > 0) {
            toast.warn(messageParts.join(", ") + ".");
          }
        }
      }
  };
  const deletePopupCancel = () => {
    setIsDelete(false)
    setSelectedToDelete(null);
  }
  //  console.log("🚀 ~ ListShowAll ~ tagListMore:", tagListMore)
  return (
    <div className='list-wrapper my-5'>
      <div className='container'>
        {isDelete &&
          <div className="modal-admin-wrapper multiple-upload" >
            <div className="modal-ad-popup modal-md">
              <div className="modal-innerpopup ">
                <div className="modal-headdiv d-flex justify-content-between text-center">
                  <h5 className="modal-head">Deleting this video will also remove the original file and all associated segments. Are you sure you want to proceed?</h5>
                  {/* <span className="closeBtn"><IoCloseOutline size={32} onClick={() => cancelpopup()} /></span> */}
                </div>
              </div>
              <div className="tag-popup-footer">
                <div className="d-flex align-items-center gap-2">
                  <button
                    type="button"
                    className="accept-all-btn w-100 py-2 accept-all-gray"
                    onClick={() => deletePopupCancel()}
                  >
                    Cancel
                  </button>

                  <button
                    type="button"
                    className="accept-all-btn w-100 py-2 d-flex align-items-center gap-2 justify-content-center"
                    onClick={() => deleteList()}
                  >
                    Ok
                  </button>
                </div>
              </div>
            </div>
          </div>}
        <div className='row'>
          <div className='col-md-9'>
            {searchText && (
              <>
                {(tagNames.length > 0 && !tagNameFlag) && (
                  <p className='banner-search-text text-start'>
                    Did you mean:
                    {tagNames.map((name, i) => (
                      <span
                        className='f-medium banner-search-text-span'
                        key={i}
                        onClick={() => {
                          dispatch(setSearchText(name))
                        }}
                      >
                        {name}
                      </span>
                    ))}
                  </p>
                )}
                <p className='text-dark' style={{ fontSize: "20px" }}>
                  These are results for <span className='theme-color fst-italic'>{searchText}</span>
                </p>
              </>
            )}

          </div>
          {(selectedVideoIds.length > 0 || videoIDsIndividual.length > 0) && (
            <>
              {isShareLink &&
                <div className="modal-admin-wrapper multiple-upload" >
                  <div className="modal-ad-popup modal-md">
                    <span className="closeBtn closeBtn_file">
                      <IoCloseOutline onClick={() => cancelPopup()} size={32} />
                    </span>
                    <div className="modal-innerpopup">

                      <div className="row mb-3">
                        <div className='col-lg-8 col-6'>
                          <h5 className="modal-head mb-0 text-start mt-2">Anyone with the link</h5>
                        </div>
                        <div className='col-lg-4 col-6 '>
                          <select name="" id="" className='form-control form-select-drop' onChange={(e) => {
                            setShareMode(e.target.value)
                            if (e.target.value === "Download") {
                              setIsDownload(true)
                            } else {
                              setIsDownload(false)
                            }
                          }} >
                            <option value="Viewer" selected >View only</option>
                            <option value="Download">Download</option>
                          </select>
                          {/* {isDownload && */}

                          <div style={{ visibility: isDownload && hasVideo ? 'visible' : 'hidden' }}>
                            <div className="checkbox-wrapper-1 checkbox-list-select d-flex align-items-center gap-3 mt-2">
                              <div className='d-flex align-items-center gap-1'>
                                <input id={`originalVedioCheck`} className="substituted" type="checkbox" aria-hidden="true"
                                  checked={isOriginalCheck}
                                  onChange={(e) => setIsOriginalCheck(e.target.checked)}
                                />
                                <label className=" d-flex align-items-center" htmlFor={`originalVedioCheck`}
                                  style={{ fontSize: '12px' }}
                                >Original</label>
                              </div>
                              <div className='d-flex align-items-center gap-1'>
                                <input id={`mp4Check`} className="substituted" type="checkbox" aria-hidden="true"
                                  checked={isMp4Check}
                                  onChange={(e) => setIsMp4check(e.target.checked)}
                                />
                                <label className=" d-flex align-items-center" htmlFor={`mp4Check`}
                                  style={{ fontSize: '12px' }}
                                >MP4</label>
                              </div>
                            </div>
                            {!isVideoFormatSelect && (<div className='col-lg-8 col-6 d-flex align-items-center'>
                              <h6 className="modal-head mb-0 text-start" style={{ fontSize: '12px', whiteSpace: 'nowrap', color: 'red', fontWeight: 'normal' }}>Please select Video format</h6>
                            </div>)}
                          </div>

                        </div>

                      </div>


                      <div className='d-flex align-items-center gap-2'>
                        <button className="addButton add-index addButtonShare link-btns  mx-0 d-flex align-items-center gap-2"
                          style={{ top: 'unset' }}
                          onClick={() => {
                            linkCopy(selectedVideoIds, "copy")

                          }
                          }
                        >
                          <FiLink size={17}
                          />Copy link
                          <div
                            className="d-none position-absolute ms-0 mt-5 px-2 py-1 text-white bg-dark rounded"
                            id="link-copy-common" style={{ fontSize: "10px", zIndex: 10, width: "53px" }}
                          >
                            Copied!
                          </div>
                        </button>
                        <button className="addButton add-index addButtonShare link-btns mx-0 d-flex align-items-center gap-2"
                          style={{ top: 'unset' }} onClick={() => listSharePopup(selectedVideoIds, "mail")}
                        >
                          <FiMail size={17}
                          />Share by Email
                        </button>
                      </div>

                    </div>
                  </div>
                </div>}
            </>
          )}

          {isMultipleDownload &&
            <div className="modal-admin-wrapper" >
              <div className="modal-ad-popup modal-md">
                <div className="modal-innerpopup ">
                  <span className="closeBtn"><IoCloseOutline size={32} onClick={() => cancelpopup()} /></span>
                  <div className="modal-headdiv d-flex justify-content-between">
                    <h5 className="modal-head">Download Files!</h5>
                    <div className="d-flex align-items-center gap-2 flex-wrap">
                      <div className="d-flex align-items-center gap-2"> <BiFile /><strong>{(selectedDownloadVideoMode === "Single" ? selectedDownloadVideo.length : selectedDownloadVideoALL.length)} file(s), {totalFileSize} </strong></div>
                    </div>
                  </div>
                  <div className="modal-admin-body my-3" style={{ maxHeight: 'calc(100vh - 290px)' }}>
                    <div className="table-responsive">

                      <table className="table table-bordered admin-list-table">
                        <tbody>
                          {(selectedDownloadVideoMode === "Single" ? selectedDownloadVideo : selectedDownloadVideoALL).map((data, i) => {

                            return (
                              < tr key={i} >
                                <td style={{ width: '40%', minWidth: '250px' }} className='text-start'>{data.video_heading}{"." + data.file_extension}</td>
                                <td style={{ width: '20%', minWidth: '100px' }} className='text-center'>
                                  {selectedQualities[data.video_id]?.size
                                    ? `${selectedQualities[data.video_id].size} MB`
                                    : (data.download_mp4 && !data.download_original) ? `${data.qualityTypeArray[0].qualityvideosize} MB` : `${data.size} MB`} </td>


                                <td style={{ width: '40%', minWidth: '250px' }} className='text-center'>
                                  {props.userData.roleDisplayName === "User" &&
                                    // (data.downloadStatus === "APPROVED" ?
                                    <div className="d-flex align-items-center gap-3"
                                      style={{ color: '#00627B' }}
                                    >
                                      <select name="" id="" className='form-control form-select-drop'
                                        value={selectedQualities[data.video_id]?.quality || "Download Original"}
                                        onChange={(e) =>
                                          handleVideoQualityChange(data.video_id, e.target.value, data.qualityTypeArray)
                                        }
                                      >
                                        {(data.download_original || props?.userData?.hasFullAccess) &&
                                          <option value="Download Original" >Download Original</option>}
                                        {(data.download_mp4 || props?.userData?.hasFullAccess) &&
                                          data.qualityTypeArray.map((obj, j) => (
                                            <option key={j} value={obj.qualitytype}>{obj.qualitytype}</option>
                                          ))}
                                      </select>

                                      <span style={{ flex: 'none' }} onClick={() => handleSingleDownload(data, selectedQualities[data.video_id])}>
                                        {/* {loadingStatusIndex === data.video_id ? "Downloading..." :  */}
                                        <FaDownload /></span>
                                    </div>
                                    // : "Waiting for Approval")
                                  }
                                  {['Admin', 'Super_admin'].includes((props.userData?.roleDisplayName)) &&

                                    <div className="d-flex align-items-center gap-3"
                                      style={{ color: '#00627B' }}
                                    >
                                      <select name="" id="" className='form-control form-select-drop'
                                        value={selectedQualities[data.video_id]?.quality || "Download Original"}
                                        onChange={(e) =>
                                          handleVideoQualityChange(data.video_id, e.target.value, data.qualityTypeArray)
                                        }
                                      >

                                        <option value="Download Original" >Download Original</option>
                                        {
                                          data.qualityTypeArray.map((obj, j) => (
                                            <option key={j} value={obj.qualitytype}>{obj.qualitytype}</option>
                                          ))}
                                      </select>

                                      <span style={{ flex: 'none' }} onClick={() => handleSingleDownload(data, selectedQualities[data.video_id])}>
                                        {/* {loadingStatusIndex === data.video_id ? "Downloading..." :  */}
                                        <FaDownload /></span>
                                    </div>

                                  }
                                </td>
                              </tr>
                            )
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="tag-popup-footer">
                    {!isDownloadBtn &&
                      <div className="d-flex align-items-center gap-2">
                        <button
                          type="button"
                          className="accept-all-btn w-100 py-2 accept-all-gray"
                          onClick={() => cancelpopup()}
                        >
                          Cancel
                        </button>

                        <button
                          type="button"
                          className="accept-all-btn w-100 py-2 d-flex align-items-center gap-2 justify-content-center"
                          onClick={() => handleDownloadAll()}
                        >
                          Download all <BiDownload className="ms-0" />
                        </button>
                      </div>}
                  </div>
                </div>
              </div>
            </div>}


          {tagListMore.length > 0 && (
            <div className="col-md-3 filter-section mb-3 filert-view-mobile">
              {selectedDownloadVideoALL.length > 0 &&

                <button className="btn-listing-btn" onClick={() => downloadMultiple()}
                // onClick={() => downloadAll()}
                >
                  {/* {isLoading ?
    (<RiLoader4Fill className="loader-icon" />) : */}
                  <HiDownload />
                  {/* } */}
                </button>}
              {

                (videoIDsIndividual.length === 0 && selectedVideoIds.length > 0 && props.userData?.roleDisplayName !== "User") && (
                  <button className="addButton add-index addButtonShare me-3"
                    onClick={() => {
                      url = `${window.location.href}share/${uuidv4()}`
                      setIsShareLink(true)
                      // const shareElement = document.getElementById("share-common");
                      // if (shareElement) {
                      //   shareElement.classList.toggle("d-none");
                      // }
                    }}>
                    <IoShareSocialOutline size={17} />
                  </button>
                )
              }

              <div className='list-grid-btns'>
                <div
                  className={`list-grid-div ${viewType === 'grid' ? 'active' : ''}`}
                  onClick={() => dispatch(setViewType('grid'))}
                >
                  <div className='grid-fill'>
                    <div className='grid-inner-fill'>
                      <div className='grid-dot-fill'></div>
                      <div className='grid-dot-fill'></div>
                      <div className='grid-dot-fill'></div>
                    </div>
                    <div className='grid-inner-fill'>
                      <div className='grid-dot-fill'></div>
                      <div className='grid-dot-fill'></div>
                      <div className='grid-dot-fill'></div>
                    </div>
                    <div className='grid-inner-fill'>
                      <div className='grid-dot-fill'></div>
                      <div className='grid-dot-fill'></div>
                      <div className='grid-dot-fill'></div>
                    </div>
                  </div>
                </div>
                <div
                  className={`list-grid-div ${viewType === 'list' ? 'active' : ''}`}
                  onClick={() => dispatch(setViewType('list'))}
                >
                  <div className='list-bar'>
                    <div className='inner-list-bar'></div>
                    <div className='inner-list-bar'></div>
                    <div className='inner-list-bar'></div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <div>
          <div className={`list row g-4 ${viewType === 'grid' ? 'row-cols-1 row-cols-md-2 row-cols-lg-3' : 'row-cols-1 list-view-div'}`}>
            {tagListMore.map((data, i) => (
              <div
                className="list-sub col"
                key={data.id || `item-${i}`}
                ref={i === tagListMore.length - 6 ? lastElementRef : null}
              >

                <div className='position-relative'>

                  <div className={`card ${viewType === 'grid' ? '' : 'list-view'}`}>
                    <div className='position-relative loader-image-div'
                      onMouseEnter={() => handleMouseEnter(data?.id)}
                      onMouseLeave={() => handleMouseLeave(data?.id)}
                    >
                      {/* {(!props.isAuthenticated || ((props.isAuthenticated && props.userData.roleDisplayName === "User"))) && (
                        <div className='download-sec'>

                          {props.userData.roleDisplayName === "User" &&
                            <div className='adminIconMainLt'>

                              <label className="custom-checkbox">
                                <input type="checkbox"
                                  name={data.filename}
                                  // checked={selectedDownloadVideo[i]}
                                  checked={(data.video_id == data.id ? selecteddownloadItems.includes(data.video_id) : selecteddownloadItems.includes(data.id))}
                                  // checked={selectedDownloadVideo.some(item => item.video_id === data.video_id)}
                                  onChange={(e) => handledownloadCheckboxChange(e, data, data.id)}
                                />
                                <span className="checkmark"></span>
                              </label>
                              <HiDownload className='list-download' size={18} id={`download-btn${i}`} onClick={() => downloadSingle(data, i)} />
                            </div>}

                          <div className='icon-download icon-loader' id={`loader-btn${i}`} style={{ display: "none" }}>
                            <div className="spinner-border text-white" role="status">
                              <span className="visually-hidden">Loading...</span>
                            </div>
                          </div>
                        </div>
                      )} */}
                      {data.file_type_id == "1" ? (
                        <div className="position-relative image-container">
                          <img className="card-img-top" alt="..."
                            src={data.url} key={data.url}
                            onContextMenu={(event) => event.preventDefault()}
                            onClick={() => popupTagShow(data)} />
                          <MdOutlineZoomOutMap className='img-zoom' onClick={() => popupTagShow(data)} />
                        </div>
                      ) : (
                        <>
                          <video
                            key={data.url}
                            poster={data?.thumbnail_image}
                            controls={hoveredVideoId === data.id}
                            controlsList="nodownload"
                            onContextMenu={(event) => event.preventDefault()}
                            className="w-100"
                            onPlay={() => {
                              if (!props.isAuthenticated) {
                                window.location.href = "/login";
                              }
                            }}
                            onTimeUpdate={(e) => {
                              const video = e.target;
                              if (searchType != 0 && data.end_time_totalseconds && video.currentTime >= data.end_time_totalseconds) {
                                video.pause();
                                video.currentTime = data.start_time_totalseconds || 0;
                              }
                            }}
                            onLoadedMetadata={(e) => {
                              if (searchType != 0) {
                                const video = e.target;
                                video.currentTime = data.start_time_totalseconds || 0;
                              }
                            }}
                            ref={(el) => {
                              videoRefs.current[data.id] = el;
                              if (el) {
                                el.playbackRate = currentPlaybackRate;
                                el.volume = volume;
                                el.muted = isMuted;
                              }
                            }}
                            onVolumeChange={handleVolumeChange}
                          >
                            <source src={""} type="video/mp4" />
                            Your browser does not support HTML5 video.
                          </video>

                          {hoveredVideoId === data.id && (
                            <>
                              <div className='position-relative'
                                ref={popupRef}
                              >
                                <button
                                  onClick={() => toggleSettings(data.id)}
                                  className="settings-btn-qta"
                                >
                                  <IoSettingsSharp className={`active-settings-btn ${activeSettings ? "active" : ''}`} />
                                </button>
                                {activeSettings === data.id && (
                                  <div className={`video-control-popup                              
                                   ${speedFlag && quality ? '' : 'active'}`}

                                  >
                                    <div className='show-playback-list'>
                                      <div className="playback-btn"
                                        onClick={() => showQuality()}
                                      >
                                        <MdTune />
                                        Quality
                                        <div className='popup-list-items'>
                                          <span className='popup-list-quality'>({selectedQuality}p)</span>
                                          <MdKeyboardArrowRight />
                                        </div>
                                      </div>
                                      <div
                                        className="playback-btn"
                                        onClick={() => showSpeed()}
                                      >
                                        <MdOutlinePlayCircle />
                                        Playback speed
                                        <div className='popup-list-items'>
                                          {currentPlaybackRate}
                                          <MdKeyboardArrowRight />
                                        </div>
                                      </div>
                                      <div className="playback-btn" onClick={() => handlePiP(data.id)}>
                                        {pipVideoId === data.id
                                          ? <>
                                            <MdCloseFullscreen />
                                            Exit PiP
                                          </>
                                          : <>
                                            <MdPictureInPicture />
                                            Picture-in-Picture
                                          </>
                                        }
                                      </div>
                                    </div>
                                    <div ref={dropdownRef} className={`quality-dropdown-qta ${quality ? '' : 'active'}`}>
                                      <div className='playback-btn palback-back-div'
                                        onClick={() => backToQuality()}
                                      >
                                        <MdKeyboardArrowLeft />
                                        Quality
                                      </div>
                                      {data?.video_variants.map((quality) => (
                                        <>
                                          <p key={quality.quality_type} className="quality-dropdown-p"
                                            onClick={() => handleQualityChange(quality.quality_type)}>
                                            <input
                                              type="radio"
                                              id={`${data.id}-${quality.quality_type}`}
                                              className="quality-radio-input"
                                              name="global-quality"
                                              value={quality.quality_type}
                                              checked={selectedQuality === quality.quality_type}
                                              defaultChecked={selectedQuality}
                                              onChange={() => handleQualityChange(quality.quality_type)}
                                            />
                                            <label htmlFor={`${data.id}-${quality.quality_type}`}>{quality.quality_type}</label>
                                          </p>
                                        </>
                                      ))}
                                    </div>
                                    <div className={`show-playback-items ${speedFlag ? '' : 'active'}`}>
                                      <div className='playback-btn palback-back-div'
                                        onClick={() => backToList()}
                                      >
                                        <MdKeyboardArrowLeft />
                                        Playback speed
                                      </div>
                                      {speeds.map((s) => (
                                        <div
                                          key={s.value}
                                          className={`playback-btn ${currentPlaybackRate === s.value ? 'selected' : ''}`}
                                          onClick={() => {
                                            handlePlaybackRateChange(s.value, data.id);
                                          }}
                                        >
                                          {s.label}
                                        </div>
                                      ))}
                                    </div>


                                  </div>
                                )}
                              </div>
                            </>
                          )}
                        </>
                      )}
                      {/* {(props.userData?.roleDisplayName === "Admin" || props.userData?.roleDisplayName === "Super_admin") && */}
                      {(props.isAuthenticated) &&
                        <div className="adminIconMain">
                          <div className='adminIconMainLt'>
                            {(props.userData.roleDisplayName !== "User") && (

                              <button className="editIcon mb-0">
                                {data.userDisplayName}
                              </button>)}
                            {(props.userData?.roleDisplayName === "Admin" || props.userData?.roleDisplayName === "Super_admin" || props.userData?.roleDisplayName === "User") &&
                              <label className="custom-checkbox">
                                <input type="checkbox"
                                  name={data.filename}
                                  // checked={selectedVideoIds[i]}  
                                  checked={(data.video_id == data.id ? selectedItems.some(item => item.id === data.video_id) : selectedItems.some(item => item.id === data.id))}
                                  onChange={(e) => handleCheckboxChange(e, data.video_id, data.file_type_id, data.id, data)}
                                />
                                <span className="checkmark"></span>
                              </label>
                            }
                          </div>
                          <div class="adminIconMainRt position-relative">

                            {(props.userData?.roleDisplayName === "Admin" || props.userData?.roleDisplayName === "Super_admin") &&
                              <>
                                <button className="editIcon"
                                  onClick={() => {
                                    setVideoIDsIndividual([data.video_id])
                                    setSelectedVideoIds([])
                                    setIsShareLink(true)
                                    if (data.file_type_id == "2") {
                                      setHasVideo(true)

                                    } else {
                                      setHasVideo(false)
                                    }
                                    // // setActiveShareIndex(prev => (prev === index ? null : index))
                                    url = `${window.location.href}share/${uuidv4()}`
                                  }}
                                >

                                  <IoShareSocialOutline size={17} />
                                </button>
                                <button className="editIcon"
                                  onClick={() => listPopup(data, "Edit", i)}
                                >
                                  <FiEdit2 size={17} />
                                </button>
                                <button className="editIcon"
                                  onClick={() => {
                                    setSelectedToDelete(data);
                                    setIsDelete(true)
                                    // window.scrollTo({ top: 0, behavior: 'smooth' }); 
                                    // deleteList(data)
                                  }}
                                >
                                  <RiDeleteBinLine size={17} />
                                </button>

                              </>
                            }


                            {(!props.isAuthenticated || ((props.isAuthenticated && props.userData.roleDisplayName !== "APPROVER"))) && (
                              <button className="editIcon">
                                <HiDownload size={17}
                                  id={`download-btn${i}`} onClick={() => downloadSingle(data, i)}

                                //onClick={() => downloadFn(list, index)} 
                                />
                                <div className='icon-download icon-loader' id={`loader-btn${i}`} style={{ display: "none" }}>
                                  <div className="spinner-border" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                  </div>
                                </div>
                              </button>
                            )}
                          </div>
                        </div>
                      }

                    </div>
                    <div className="card-body"
                      style={{ flexDirection: 'column', alignItems: 'flex-start' }}
                    >
                      {((viewType === "list") && ((!props.isAuthenticated) || (props.isAuthenticated && props.userData?.roleDisplayName === "User"))) &&
                        <div className='col-md-12 listBtnDiv'>
                          {data.file_type_id && <span className="listBtnView">
                            {data.file_type_id == 2 ? (
                              <>
                                <GrMultimedia /> Video
                              </>
                            ) : (
                              <>
                                <MdOutlinePermMedia /> Image
                              </>
                            )}                      </span>}
                          {data.video_date && <span className="listBtnView"><CiCalendarDate />{data.video_date}</span>}
                          {data.video_location && <span className="listBtnView"><IoLocationOutline />{data.video_location}</span>}
                          {data.size && <span className="listBtnView"><IoIosResize />{data.size}</span>}
                        </div>
                      }
                      <h5 className="card-title">{data.video_heading}</h5>
                      <p className="card-text">{data.description}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          {(loadingTag == "true") &&
            <div className="d-flex flex-column text-center">
              <div>
                <img src={Loader} alt="noData" className="img-fluid" width="100" height="100" />
              </div>
            </div>
          }
          {((loadingTag == "false") && tagListMore.length == 0) &&
            <div className="d-flex flex-column text-center pt-3">
              <div>
                <p>No data found</p>
              </div>
            </div>
          }
        </div>
      </div>
      {tagPopupFlag && (
        <ListPopup
          cancelPopup={cancelpopup}
          userData={props.userData}
          isAuthenticated={props.isAuthenticated}
          selectedData={selectedData}
        />
      )}
      {popupList &&
        <ListUpload userData={props?.userData}
          cancelPopup={cancelPopup} getData={props.getData} getCloudBucketData={props.getCloudBucketData}
          sendMail={sendMail} selectData={selectData} mode={mode} selectIndex={selectIndex} />
      }
    </div>
  );
}

export default ListShowAll;